var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-dollar",
    d: "M-402,41a11.921,11.921,0,0,1-8.485-3.515A11.922,11.922,0,0,1-414,29a11.921,11.921,0,0,1,3.515-8.485A11.921,11.921,0,0,1-402,17a11.923,11.923,0,0,1,8.486,3.515A11.921,11.921,0,0,1-390,29a11.922,11.922,0,0,1-3.515,8.486A11.922,11.922,0,0,1-402,41Zm-4.636-9.769v3.846a3.979,3.979,0,0,0,1.523.559,11.708,11.708,0,0,0,2.322.282V38h2.431V35.641a5.481,5.481,0,0,0,1.984-.917,4.213,4.213,0,0,0,1.236-1.456,3.961,3.961,0,0,0,.42-1.8,3.726,3.726,0,0,0-.938-2.527,7.9,7.9,0,0,0-2.969-1.9,5.413,5.413,0,0,1-1.348-.723,1.052,1.052,0,0,1-.415-.835.8.8,0,0,1,.348-.662,1.486,1.486,0,0,1,.913-.262,6.6,6.6,0,0,1,1.922.3,7.387,7.387,0,0,1,1.769.789V21.911a12,12,0,0,0-2.922-.462V19.512h-2.431v2.04a5.176,5.176,0,0,0-2.958,1.487,4.026,4.026,0,0,0-1.071,2.84c0,1.932,1.114,3.354,3.312,4.225a12.115,12.115,0,0,1,1.327.595,2.3,2.3,0,0,1,.641.476.933.933,0,0,1,.2.621.911.911,0,0,1-.313.728,1.283,1.283,0,0,1-.856.266A7.033,7.033,0,0,1-406.636,31.232Z",
    transform: "translate(414 -17)",
    fill: "#535353",
    opacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollar);
export default __webpack_public_path__ + "static/media/icon-dollar.4782b1dcbea50c3c29f51bb135bc008b.svg";
export { ForwardRef as ReactComponent };